import { format, formatDistanceToNow } from 'date-fns';
import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export const cn = (...inputs) => {
  return twMerge(clsx(inputs));
};

export const formatDate = (date) => {
  if (!date) return 'N/A';
  return format(new Date(date), 'MMM dd, yyyy');
};

export const formatDateTime = (date) => {
  if (!date) return 'N/A';
  return format(new Date(date), 'MMM dd, yyyy HH:mm');
};

export const formatTimeAgo = (date) => {
  if (!date) return 'N/A';
  return formatDistanceToNow(new Date(date), { addSuffix: true });
};

export const getStatusColor = (status) => {
  const colors = {
    Draft: 'status-draft',
    Pending_EAC_Review: 'status-submitted',
    Pending_SDO_Review: 'status-submitted',
    Pending_ADC_Review: 'status-under-review',
    Pending_DC_Approval: 'status-under-review',
    Active: 'status-approved',
    Cancelled: 'status-rejected',
    Transferred: 'status-returned',
    Renewal_Needed: 'status-warning',
    Returned: 'status-returned'
  };
  return colors[status] || 'status-draft';
};

export const getStatusText = (status) => {
  const statusTexts = {
    Draft: 'Draft',
    Pending_EAC_Review: 'Pending EAC Review',
    Pending_SDO_Review: 'Pending SDO Review',
    Pending_ADC_Review: 'Pending ADC Review',
    Pending_DC_Approval: 'Pending DC Approval',
    Active: 'Active',
    Cancelled: 'Cancelled',
    Transferred: 'Transferred',
    Renewal_Needed: 'Renewal Required',
    Returned: 'Returned'
  };
  return statusTexts[status] || status;
};

export const getRoleText = (role) => {
  const roleTexts = {
    bo: 'Branch Officer',
    eac: 'EAC',
    sdo: 'SDO',
    adc: 'ADC',
    dc: 'DC'
  };
  return roleTexts[role] || role;
};

export const formatFileSize = (bytes) => {
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
};

export const formatArea = (area) => {
  if (!area) return 'N/A';
  return `${area.toLocaleString()} sq m`;
};

export const downloadFile = (data, filename, type = 'application/octet-stream') => {
  const blob = new Blob([data], { type });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};

export const validateEmail = (email) => {
  const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return re.test(email);
};

export const validatePermitNumber = (permitNumber) => {
  const re = /^MON\/\d{4}\/\d{4}$/;
  return re.test(permitNumber);
};